import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Page } from "@/components";
import type { InternLenke } from "@/components/LenkerContainer";
import { DokumentasjonsLenker } from "../dokumentasjon/DokumentasjonsLenker";
import { useSelskaper } from "../selskap/SelskapContext";
import { VeiledningLenke } from "../shared/VeiledningLenke";
import { MaaledataPerioderListe } from "./MaaledataPerioderListe";
import { Kjøreplaner } from "./periode/Kjøreplaner";
import { SimuleringsområdeLenke } from "./simulering/SimuleringsområdeLenke";
import { TestområdeLenke } from "./validering/TestområdeLenke";

export const MaaledataPerioderPage = () => {
  const { t } = useTranslation();

  const avtalerEksportLenke: InternLenke = {
    href: "/dokumentasjon/innrapportering",
    text: t("pages.dokumentasjon.lenker.innrapportering"),
    external: false,
  };
  const { active } = useSelskaper();
  return (
    <Page>
      <div className="flex flex-col gap-4 xl:flex-row xl:justify-between">
        <div className="max-w-card w-full space-y-6">
          <div className="space-y-6">
            <Heading data-size="md">
              {t("pages.maalerdata-perioder.tittel")}
            </Heading>
            <Paragraph>{t("pages.maalerdata-perioder.beskrivelse")}</Paragraph>
            <Kjøreplaner />
          </div>

          <div>
            {active == null ? (
              <Alert data-color={"warning"}>
                <span>{t("pages.bestillinger.ingen-selskap")}</span>
                <br />
                <Link to="/selskap">{t("selskap-header.bytt-selskap")}</Link>
              </Alert>
            ) : (
              <MaaledataPerioderListe
                organisasjonsNummer={active.organisasjonsnummer}
              />
            )}
          </div>
        </div>
        <div className="max-w-small-card space-y-6">
          <VeiledningLenke />
          <TestområdeLenke />
          <SimuleringsområdeLenke />
          <DokumentasjonsLenker
            lenker={[avtalerEksportLenke]}
            className="w-full"
          />
        </div>
      </div>
    </Page>
  );
};
